module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAPklEQVQ4T2NkoBJgpJI5DNQ36MyZM/8pcR3cRVQ3yMTEhCTvwhyA4aJRg+ARPBpGhNP6EAojwp7BroJqmRYAQW1e4Njpd34AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/react.png
// module id = ErbA
// module chunks = 136